import React from "react";
import { Link, useParams } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import products from "../components/loungeproductpage-components/loungeproducts";
import LoungeProductpageCarousel from "../components/loungeproductpage-components/LoungeProductpageCarousel";
import LoungeProductpageAccordion from "../components/loungeproductpage-components/LoungeProductpageAccordian";
import AddToCart from "../components/cart-components/AddToCart";
import "../styles.css";

const LoungeProductpage = () => {
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  if (!product) {
    return <div>Product not found</div>;
  }

  return (
    <div className="page-content">
      <Row>
        {/* Breadcrumb navigation */}
        <div className="breadcrumb-navigation">
          <Link to="/">Home</Link> &gt;{" "}
          <Link to="/loungeProducts">Lounge Products</Link> &gt;{" "}
          <Link to={`/loungeProducts/${product.slug}`}>
          </Link> &gt; {product.name}
        </div>
        <div>
          <Row>
            <Col lg={6} md={12}>
              <LoungeProductpageCarousel />
            </Col>
            <Col lg={6} md={12}>
              <AddToCart product={product} />
              <LoungeProductpageAccordion />
            </Col>
          </Row>
          {product.situImg && (
            <Row>
              <Col lg={12} md={12}>
                <img
                  src={product.situImg}
                  alt="Product in situ"
                  className="situ-img"
                />
              </Col>
            </Row>
          )}
        </div>
      </Row>
    </div>
  );
};

export default LoungeProductpage;
